"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _RelatedTopicsList = _interopRequireDefault(require("./RelatedTopicsList"));

var _components = require("@insided/shared/services/algolia/components");

var _algolia = require("@insided/shared/services/algolia");

var _algoliaService = require("../../services/algoliaService");

var _utils = require("@insided/destination/modules/Search/utils");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RelatedTopics = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(RelatedTopics, _Component);

  var _super = _createSuper(RelatedTopics);

  function RelatedTopics(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RelatedTopics);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "communityId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "topicId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "topicTitle", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cb", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data) {
        var searchClient;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _algolia.createAlgoliaClient)(data.client_id, data.token);

              case 2:
                searchClient = _context.sent;

                _this.setState({
                  clientId: data.client_id,
                  token: data.token,
                  hiddenCategories: data.hiddenCategories,
                  searchClient: searchClient
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.communityId = (0, _utils.getCommunityId)();
    var inSidedData = (0, _insidedDataStorage.getInsidedData)('content');
    _this.topicId = inSidedData.topic.id;
    _this.topicTitle = inSidedData.topic.title;
    _this.cb = _this.cb.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(RelatedTopics, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _algoliaService.getSearchToken)(this.cb);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var state = this.state;
      if (!state.clientId || !state.token || !state.searchClient) return null;
      return (0, _preact.h)("div", null, (0, _preact.h)(_components.InstantSearch, {
        searchClient: state.searchClient,
        indexName: this.communityId
      }, (0, _preact.h)(_components.Configure, {
        queryType: "prefixNone",
        query: this.topicTitle,
        hitsPerPage: parseInt(props.pageSize) + 1,
        removeWordsIfNoResults: "allOptional",
        optionalWords: this.topicTitle,
        analyticsTags: ['destination', 'related'],
        filters: (0, _utils.getFilters)({
          hiddenCategories: state.hiddenCategories
        })
      }), (0, _preact.h)(_RelatedTopicsList.default, {
        topicId: this.topicId,
        totalItemCount: props.pageSize,
        widgetTitle: props.widgetTitle
      })));
    }
  }]);
  return RelatedTopics;
}(_preact.Component);

var _default = RelatedTopics;
exports.default = _default;